import { useEffect } from "react";
import { AppRoutes } from "../../constants";
import { useAppDispatch } from "../../redux";
import { getTokenDataAction } from "../../AppSlice";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

export default function _Portal() {
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const token = params.get("token");

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    const start = async () => {
      async function getData() {
        if (token) {
          await dispatch(getTokenDataAction({ token }));

          navigate(AppRoutes.home);
        }
      }

      await getData();
    };

    start();
  }, [token]);

  if (!token) return <Navigate to={AppRoutes.home} />;

  return null;
}
